import AjaxComponentLoader from 'utils/ajax_component_loader';
import ModalManager from 'utils/modal_manager';

export default class SessionExpired {
  static renewSessionModal(return_url) {
    AjaxComponentLoader.load({
      component: 'modals/session_expired_modal',
      type: 'component',
      data: {
        return_url: return_url
      }
    })
      .then(html => {
        $('body').append(html);

        if (gon.flags.session_expired_debug) {
          UserTracker.emit('event', {
            eventName: 'expired session',
            data: {
              request_path: window.location.pathname,
              cookie_my_app_session: Boolean(window.currentUser),
              cookie_remember_user_token: Boolean(window.currentUser)
            }
          });
        }

        ModalManager.open('#js-session-expired-modal');
      })
      .catch(() => {
        Turbolinks.visit(`/conta/entrar?return_url=${return_url}`);
      });
  }
}
